export default {
    hasCustomBackground: true
}
